export default {
    hasCustomBackground: true
}
